export default __webpack_public_path__ + "static/media/challenge-title.a0a2fccd.png";